module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-travel.component.css
// module id = ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-travel.component.css
// module chunks = main